import { DatePipe } from '@angular/common';
import { HostListener, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { CalidadModule } from '../../modelo/calidad/calidad.module';
import { CalidadService } from '../../servicios/calidad.service';

@Component({
  selector: 'app-calidad',
  templateUrl: './calidad.component.html',
  styleUrls: ['./calidad.component.css']
})
export class CalidadComponent implements OnInit {
  listaCalidad: CalidadModule[];
  searchText: string = '';
  urlImagen:SafeHtml;
  calidad:CalidadModule;

  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;

  @ViewChild(MdbTablePaginationComponent) mdbTablePaginationDet: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTableDet: MdbTableDirective;

  @ViewChild('lgModal') public lgModal: ModalDirective;
  previous: any = [];
  fecha: string;

  constructor( private sanitizer: DomSanitizer, private datePipe: DatePipe, private api: CalidadService, private ruter: Router, private alertService: AlertService) { }
  @HostListener('input') oninput() {
    this.searchItems();
  }

  ngOnInit(): void {
    this.listaCalidad = [];
    this.calidad= new CalidadModule();
    
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.listaCalidad = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.listaCalidad = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }



  buscar() {
    this.searchText = '';
    this.api.listarCalidad(this.datePipe.transform(this.fecha, "dd-MM-yyyy"))
      .subscribe((
        data: CalidadModule[]) => {
        this.listaCalidad = data;
        console.log(this.listaCalidad);

        this.mdbTable.setDataSource(this.listaCalidad);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
  }

  verDetalle(calidad1:CalidadModule){

    this.urlImagen = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' 
                 + calidad1.foto);
this.calidad=calidad1;
    this.lgModal.show();

  }


}
